import React from 'react';
import {Space} from 'antd';
import {observer} from "mobx-react";
import {useNavigate} from "react-router-dom";
import * as Role from "../index";

export const Edit: React.FC = observer(() => {
    const navigate = useNavigate();

    const onCancel = () => {
        navigate(`/role`)
    }

    return (
        <Space direction="vertical" size="small" style={{ display: 'flex' }}>
            <Role.EditForm onCancel={onCancel} />
        </Space>
    )
})